"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _dealersAddresses = require("@/api/dealers-addresses");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _admin = require("@/store/modules/admin");
var _common = require("@/common");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.isAgent = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.dealerId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      name: undefined,
      dealerId: 0,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        name: '$startsL',
        enabled: '$eq',
        dealerId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    if (_admin.AdminModule.userType === 'Agent') {
      this.isAgent = true;
    }
    this.dealerId = parseInt(this.$route.params && this.$route.params.dealerId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
  }
  hasNoAccess(requiredRoles) {
    return (0, _common.isExcludedToAccess)(requiredRoles);
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.dealerId = this.dealerId;
      const data = await (0, _dealersAddresses.getDealersAddresses)((0, _index2.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  async handlePdf(id) {
    try {
      if (id) {
        const url = await (0, _dealersAddresses.downloadEnvelopePdf)(id);
        if (url.url) {
          window.open(url.url, '_blank');
        } else {
          this.$message({
            message: 'Failed to generate ledger',
            type: 'error'
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  getAddress(address) {
    let fullAaddress = '';
    if (address.line1) {
      fullAaddress += 'Line 1: ' + address.line1 + '<br />';
    }
    if (address.line2) {
      fullAaddress += 'Line 2: ' + address.line2 + '<br />';
    }
    if (address.city) {
      fullAaddress += 'City: ' + address.cityName + '<br />';
    }
    if (address.state) {
      fullAaddress += 'State: ' + address.state.name + '<br />';
    }
    if (address.pincode) {
      fullAaddress += 'Pincode: ' + address.pincode.pincode + '<br />';
    }
    if (address.gstNumber) {
      fullAaddress += 'GST: ' + address.gstNumber + '<br />';
    }
    if (address.panNumber) {
      fullAaddress += 'PAN: ' + address.panNumber + '<br />';
    }
    return fullAaddress;
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'DealersAddressList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default
  }
})], default_1);
var _default = exports.default = default_1;